/**
 * @title 최상위 컴포넌트
 * @HongGuma
 */
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import AuthPage from './pages/Auth/AuthPage';
import NaverLoginCallback from './pages/Auth/NaverLoginCallback';
import AccountRecoveryPage from './pages/Auth/AccountRecoveryPage';
import NaverSignupPage from './pages/Auth/NaverSignupPage';
import RequireLogin from './pages/Auth/RequireLogin';
import Main from './pages/Main.js';
import AIClients from './pages/Practice/AIClients/AIClients';
import AIInterview from './pages/Practice/AIClients/AIInterview';
import ReflectionPractice from './pages/Practice/ReflectionPractice/ReflectionPractice';
import MyPractice from './pages/Practice/MyPractice/MyPractice';
import CaseConceptualizationPractice from './pages/Practice/PracticeReview/CaseConceptualizationPractice';
import ComprehensiveFeedback from './pages/Practice/PracticeReview/ComprehensiveFeedback';
import Home from './pages/Home/Home.js';
import About from './pages/About/About.js';
import Service from './pages/Service/Service.js';
import CaseConceptualization from './pages/Service/CaseConceptualization/CaseConceptualization.js';
import Solution from './pages/Solution/Solution.js';
import Contact from './pages/Contact/Contact.js';
import News from './pages/News/News.js';
import NewsDetail from './pages/News/NewsDetailPage.js';
import Lecture from './pages/Lecture/LecturePage.js';
import LectureDetail from './pages/Lecture/LectureDetailPage.js';
import PaymentPage from './pages/Lecture/Payments/Payments.js';
import Success from './pages/Lecture/Payments/Success.js';
import Fail from './pages/Lecture/Payments/Fail.js';
import Application from './pages/Lecture/ApplicationPage.js';
import MyPage from './pages/MyPage/MyPage.js';
import ProfileSection from './pages/MyPage/ProfileSection';
import AccountSection from './pages/MyPage/AccountSection';
import ActivitySection from './pages/MyPage/ActivitySection';
import InquiryFormSection from './pages/MyPage/InquiryFormSection';
import InquiryListSection from './pages/MyPage/InquiryListSection';
import InquiryDetailSection from './pages/MyPage/InquiryDetailSection';
import ComingSoonSection from './pages/MyPage/ComingSoonSection';
import AiClientFeedbackPage from './pages/MyPage/AiClientFeedbackPage';
import AiClientConceptualizationPage from './pages/MyPage/AiClientConceptualizationPage';
import AdminRoutes from './pages/Admin/AdminRoutes';

import AppDownload from './pages/AppDownloadPage.js';
import MallangGuidePage from './pages/MallangGuidePage.js';
import PrivacyPolicy from './pages/PrivacyPolicyPage.js';
import TermsOfService from './pages/TermsOfServicePage.js';

function App() {
    return (
        <Router>
            <NaverLoginCallback>
            <Routes>
                <Route path="/" element={<Main />}>
                    {/* 기본 화면 */}
                    <Route index element={<Home />} />
                    <Route path="login" element={<AuthPage mode="login" />} />
                    <Route path="register" element={<AuthPage mode="register" />} />
                    <Route path="find-email" element={<AccountRecoveryPage key="email" mode="email" />} />
                    <Route path="find-password" element={<AccountRecoveryPage key="password" mode="password" />} />
                    <Route path="signup/naver" element={<NaverSignupPage />} />
                    <Route path="about" element={<About />} />
                    <Route path="ai-clients" element={<AIClients />} />
                    <Route path="ai-clients/interview" element={<RequireLogin><AIInterview /></RequireLogin>} />
                    <Route path="reflection-practice" element={<ReflectionPractice />} />
                    <Route path="my-practice" element={<MyPractice />} />
                    <Route path="case-conceptualization" element={<RequireLogin><CaseConceptualizationPractice /></RequireLogin>} />
                    <Route path="comprehensive-feedback" element={<RequireLogin><ComprehensiveFeedback /></RequireLogin>} />
                    <Route path="service" element={<Service />} />
                    <Route path="service/case-conceptualization" element={<CaseConceptualization />} />
                    <Route path="solution" element={<Solution />} />
                    <Route path="contact" element={<Contact />} />
                    <Route path="lecture" element={<Lecture />} />
                    <Route path="lecture/:id" element={<LectureDetail />} />
                    <Route path="news" element={<News />} />
                    <Route path="news/:id" element={<NewsDetail />} />
                    <Route path="mypage" element={<RequireLogin><MyPage /></RequireLogin>}>
                        <Route index element={<Navigate to="profile" replace />} />
                        <Route path="profile" element={<ProfileSection />} />
                        <Route path="account" element={<AccountSection />} />
                        <Route path="activity" element={<ActivitySection />} />
                        <Route path="inquiry-new" element={<InquiryFormSection />} />
                        <Route path="inquiry" element={<InquiryListSection />} />
                        <Route path="inquiry/:inquiryId" element={<InquiryDetailSection />} />
                        {/* 준비 중 메뉴(myPageMenu.js의 ready: false)는 공통 안내 화면으로 연결 */}
                        <Route path=":section" element={<ComingSoonSection />} />
                    </Route>
                    <Route path="mypage/activity/:instanceId/feedback" element={<RequireLogin><AiClientFeedbackPage /></RequireLogin>} />
                    <Route path="mypage/activity/:instanceId/conceptualization" element={<RequireLogin><AiClientConceptualizationPage /></RequireLogin>} />
                </Route>
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/application" element={<Application />} />
                <Route path="/payments" element={<PaymentPage />} />
                <Route path="/payments/success/:apId" element={<Success />} />
                <Route path="/payments/fail/:apId" element={<Fail />} />
                <Route path="/app-download" element={<AppDownload />} />
                <Route path="/mallang-guides" element={<MallangGuidePage />} />
                <Route path="/admin/*" element={<AdminRoutes />} />
            </Routes>
            </NaverLoginCallback>
        </Router>
    );
}

export default App;
